export enum ESortingDirection {
    ASC = 1,
    DESC = 2
}
